import { createContext } from "react";

const fakeDataContext= createContext("")

export default fakeDataContext